import TopTitle from "../components/TopTitle";
import InscriptionImage from "../assets/img/nuevos.jpg";
import { getInscriptionPeriod } from "../utils/date";

function Admision() {
  const inscription = getInscriptionPeriod();

  return (
    <div className="main-content">
      <TopTitle title="Inscripción de nuevos ingresos" />
      <section className="bg-light">
        <div className="container">
          <div className="row align-items-center justify-content-center py-2">
            {!inscription.admision && (
              <h2 className="pb-sm-3 pb-md-5">¡Las inscripciones para el periodo académico {inscription.label} han finalizado!</h2>
            )}
            <div className="col-md-6">
              <img src={InscriptionImage} alt="Inscripción" className="img-fluid" />
            </div>
            <div className="col-md-6">
              <h4 className="pt-sm-3 pt-md-0">Proceso de inscripción</h4>
              <p className="py-2">
                Si está interesado y cumple con los requisitos, requerimos que se registre como<strong className="px-1">ASPIRANTE</strong>
                en la página de<a className="text-primary ps-1" href="https://iuta.terna.net/" target="_blank" rel="noopener noreferrer">TernaNet</a>,
                para crear su usuario y contraseña e incluir los documentos probatorios, información importante para la Institución.
              </p>
              <p className="py-2">
                El procedimiento es el siguiente:
              </p>
              <ul className="lists lists-2" role="tablist">
                <li>
                  Ingresa a<a className="text-primary ps-1" href="https://iuta.terna.net/" target="_blank" rel="noopener noreferrer">TernaNet</a>,
                  y en el cintillo negro que está en la parte superior selecciona <strong className="ps-1">REGISTRO-ASPIRANTE</strong>.
                  Llene los datos (creación del usuario y contraseña) y presiona enviar. Le aparecerá un mensaje de bienvenida.
                </li>
                <li>
                  En el menú principal, ubicado a la izquierda, elige la opción <strong className="text-bold">MÓDULOS-SOLICITUDES</strong>.
                </li>
                <li>
                  En la lista de Opciones escoge: <strong className="text-bold">{inscription.months} {inscription.year}</strong>.
                </li>
                <li>
                  Seguidamente selecciona la <strong className="text-bold">SEDE</strong> donde va cursar sus estudios:
                  Puerto La Cruz, Barcelona o Puerto Píritu.
                </li>
              </ul>
            </div>
            <ul className="lists lists-2 pt-sm-0 pt-md-2 p-2" role="tablist">
              <li>
                Selecciona la carrera a cursar y modalidad de estudios: DIURNO (presencial), SABATINO (semipresencial) o MULTIMODAL (online).
              </li>
              <li>
                En Opciones, selecciona <strong>DATOS</strong> y llena el formulario, completa todos los campos obligatorios del formulario
                (están marcados con asteriscos), y presiona el botón <strong>ENVIAR</strong> para guardar los datos. Si hay algún error el sistema te mostrará
                nuevamente el formulario resaltando en rojo los campos con problemas.
              </li>
              <li>
                En Opciones, ingresar los documentos solicitados (cédula de identidad vigente, foto, título de bachiller, notas certificadas
                o constancia de culminación), previamente digitalizados en formato JPG. Culminado el proceso, Enviar.
              </li>
              <li>
                Realice y registre su pago en la cuenta virtual, luego enviar el capture de la transacción al correo de cobranzas
                <strong className="ps-1">cobranzaiuta.anz@gmail.com</strong>, con su número de cédula y concepto de lo que está cancelando.
              </li>
              <li>
                Una vez culminado el proceso de registro, el Departamento de Control de Estudios revisa los documentos y admite al aspirante.
                Tienes un lapso de <strong>15 días hábiles</strong> para consignar los documentos (título de bachiller,
                notas de bachillerato, partida de nacimiento, OPSU, cédula y foto) en físico.
              </li>
            </ul>
          </div>
          <div>
            {/* <h4>Proceso de pago</h4>
            <p className="py-2">
              Despues de realizar el proceso de inscripción, el estudiante debe realizar el pago de la tasa de inscripción a través de los siguientes pasos:
            </p>
            <ul className="lists lists-2 pb-2" role="tablist">
              <li>En el menú principal, seleccione Cuenta Virtual - Tipo Movimiento: Depósito/Transferencia/ Pago Móvil Banesco y Plaza</li>
              <li>Registre los datos de su planilla de pago.</li>
              <li>Debe cancelar dependiendo si es alumno regular o de reingreso.</li>
            </ul>
            <h5 className="pt-4 pb-2">
              *Al momento de finalizar la inscripción de las asignaturas debe realizar el pago, recuerde que la tasa cambia diariamente.
            </h5> */}
            <h5 className="pb-2">
              *Cuando registre el monto de la transferencia, si requiere colocar decimales utilice el punto, no coloque coma para separación de miles.
            </h5>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Admision;
